import RiveAnimation from './rive-animation';

export default RiveAnimation;
